import { cn } from "@instacover/ui"
import { assertUnreachable } from "@instacover/utils"

import Cockpit from "../../images/bike/Cockpit.svg?react"
import { DamageAddMore } from "../../images/damage/DamageAddMore"
import { DamageDetail } from "../../images/damage/DamageDetail"
import BackLeftViewPhoto from "../../images/direct/BackLeftViewPhoto.png"
import BackRightViewPhoto from "../../images/direct/BackRightViewPhoto.png"
import DamagePhoto from "../../images/direct/DamagePhoto.png"
import EngineAndLicensePlatePhoto from "../../images/direct/EngineAndLicensePlatePhoto.png"
import FrontLeftViewPhoto from "../../images/direct/FrontLeftViewPhoto.png"
import FrontRightViewPhoto from "../../images/direct/FrontRightViewPhoto.png"
import InteriorPhoto from "../../images/direct/InteriorPhoto.png"
import OdometerPhoto from "../../images/direct/OdometerPhoto.png"
import VINPhoto from "../../images/direct/VINPhoto.png"
import WindshieldPhoto from "../../images/direct/WindshieldPhoto.png"
import Keys from "../../images/guide3d/Keys.svg?react"
import WindshieldDriver from "../../images/guide3d/WindshieldDriver.svg?react"
import WindshieldFromInside from "../../images/guide3d/WindshieldInterior.svg?react"
import WindshieldPassenger from "../../images/guide3d/WindshieldPassenger.svg?react"
import AccidentStatementFront from "../../images/icons/documents/AccidentStatementFront.svg?react"
import { IDBack } from "../../images/xd/artwork/guide/documents/IDBack"
import { IDFront } from "../../images/xd/artwork/guide/documents/IDFront"
import { Invoice } from "../../images/xd/artwork/guide/documents/Invoice"
import { TransferProtocol } from "../../images/xd/artwork/guide/documents/TransferProtocol"
import { Expired } from "../../images/xd/artwork/intro/Expired"
import { Vehicle } from "../../images/xd/artwork/intro/Vehicle"
import { IncompatiblePhoneDirect } from "../../images/xd/direct/artwork/error/IncompatiblePhoneDirect"
import { Extra } from "../../images/xd/direct/artwork/guide/damage/Extra"
import { MTPBack } from "../../images/xd/direct/artwork/guide/documents/MTPBack"
import { MTPFront } from "../../images/xd/direct/artwork/guide/documents/MTPFront"
import { FrontView } from "../../images/xd/direct/artwork/guide/exterior/FrontView"
import { LeftView } from "../../images/xd/direct/artwork/guide/exterior/LeftView"
import { RearView } from "../../images/xd/direct/artwork/guide/exterior/RearView"
import { RightView } from "../../images/xd/direct/artwork/guide/exterior/RightView"
import { NoCarsAround } from "../../images/xd/direct/artwork/intro/NoCarsAround"
import { Permissions } from "../../images/xd/direct/artwork/intro/Permissions"
import { PermissionsGPS } from "../../images/xd/direct/artwork/intro/PermissionsGPS"
import { PhotoAndUnderwriting } from "../../images/xd/direct/artwork/intro/PhotoAndUnderwriting"
import { PhotosAroundCar } from "../../images/xd/direct/artwork/intro/PhotosAroundCar"
import { Done } from "../../images/xd/direct/artwork/outro/Done"
import { ExtraIcons, InstructionImageProps } from "./InstructionImageType"

export const directImageUrls = [
  BackLeftViewPhoto,
  BackRightViewPhoto,
  DamagePhoto,
  EngineAndLicensePlatePhoto,
  FrontLeftViewPhoto,
  FrontRightViewPhoto,
  InteriorPhoto,
  OdometerPhoto,
  VINPhoto,
  WindshieldPhoto,
]

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function InstructionImageDirect({ iconName, animated, ...rest }: InstructionImageProps) {
  const photoClassName = cn("object-contain", rest.className)

  switch (iconName) {
    case "Dash":
    case "DashVideo":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={InteriorPhoto} />
    case "RearLeftSide":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={BackLeftViewPhoto} />
    case "FrontLeftSide":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={FrontLeftViewPhoto} />
    case "Motor":
    case "MotorVideo":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={EngineAndLicensePlatePhoto} />
    case "RearRightSide":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={BackRightViewPhoto} />
    case "FrontRightSide":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={FrontRightViewPhoto} />
    case "Odometer":
    case "OdometerVideo":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={OdometerPhoto} />
    case "Windscreen":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={WindshieldPhoto} />
    case "WindscreenFromInside":
      return <WindshieldFromInside {...rest} />
    case "WindscreenDriver":
      return <WindshieldDriver {...rest} />
    case "WindscreenPassenger":
      return <WindshieldPassenger {...rest} />
    case "Keys":
      return <Keys {...rest} />
    case "Vin":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={VINPhoto} />
    case "RearSide":
      return <RearView {...rest} />
    case "FrontSide":
      return <FrontView {...rest} />
    case "LeftSide":
      return <LeftView {...rest} />
    case "RightSide":
      return <RightView {...rest} />
    case "Damage":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={DamagePhoto} />
    case "ExtraEquipment":
      return <Extra {...rest} />
    case "VehicleRegistrationCertificateFront":
      return <MTPFront {...rest} />
    case "VehicleRegistrationCertificateBack":
      return <MTPBack {...rest} />
    case "RoadworthinessCertificateFront":
      // TODO: add correct icon
      return <MTPFront {...rest} />
    case "RoadworthinessCertificateBack":
      // TODO: add correct icon
      return <MTPBack {...rest} />
    // TODO: icon
    case "OtherDocument":
    case "TransferProtocol":
    case "AcceptanceProtocol":
      return <TransferProtocol {...rest} />
    case "IdentityCardFront":
    case "DriversLicenseFront":
      return <IDFront {...rest} />
    case "IdentityCardBack":
    case "DriversLicenseBack":
      return <IDBack {...rest} />
    case "AccidentStatementFront":
      return <AccidentStatementFront {...rest} />
    case "Invoice":
      return <Invoice {...rest} />
    case ExtraIcons.PermissionsLocation:
      return <Permissions {...rest} />
    case ExtraIcons.PermissionsGps:
      return <PermissionsGPS {...rest} />
    case ExtraIcons.MakeRoom:
      return <PhotosAroundCar {...rest} />
    case ExtraIcons.PhotoAndUnderwriting:
      return <PhotoAndUnderwriting {...rest} />
    case ExtraIcons.WatchOutOfCars:
      return <NoCarsAround {...rest} />
    case ExtraIcons.Sent:
      return <Done {...rest} />
    case ExtraIcons.Expired:
      return <Expired {...rest} />
    case ExtraIcons.Wait:
      // TODO: nemaji wait
      return <PhotoAndUnderwriting {...rest} />
    case ExtraIcons.DocumentsIntro:
      // TODO: add correct icon
      return <MTPBack {...rest} />
    case "ExtraClientData":
      // TODO: add correct icon
      return null
    case ExtraIcons.IncompatiblePhone:
      return <IncompatiblePhoneDirect {...rest} />
    case ExtraIcons.Vehicle:
      return <Vehicle {...rest} />
    case ExtraIcons.DamageDetail:
      return <DamageDetail {...rest} />
    case ExtraIcons.DamageAddMore:
      return <DamageAddMore {...rest} />
    case "Cockpit":
      return <Cockpit {...rest} />
    case "Claim":
      return <img {...rest} className={photoClassName} crossOrigin="anonymous" src={FrontLeftViewPhoto} />
    default:
      return assertUnreachable(iconName)
  }
}

export default InstructionImageDirect
